module.exports = __webpack_public_path__ + "media/images/app_buttons/button__appStore-05f9299f073d34559c5567a7d38b8d8b.svg";